import { AfterViewInit, ChangeDetectorRef, Component, ViewChild, } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { Tablev2Component } from '../tablev2/tablev2.component';

@Component({
  selector: 'app-promotion-category',
  templateUrl: './promotion-category.component.html',
  styleUrls: ['./promotion-category.component.scss']
})
export class PromotionCategoryComponent implements AfterViewInit {

  public company_uuid;
  @ViewChild("table", { static: false }) tb: Tablev2Component;

  constructor(private http: HttpService, private cdr : ChangeDetectorRef) {
    this.http.getSelectedCompany().subscribe(val => {
      this.company_uuid = val;
    });
   }

   ngAfterViewInit(): void {
    this.init();
  }

  async init() {
    const setting = 
        { post: {url: "/admin/app/promotion-category/get", data: {}},
          disabled_pagenat: true,
          fields: [
            {label: 'No', type: 'index'}, 
            {label: 'Title', type: 'string', key: 'title'}, 
            {label: 'Sort', type: 'number', key: 'sort'}, 
            {label: 'Status', type: 'status', key: 'status'}, 
            {label: 'View', type: 'link', key: 'uuid', 'link': '/lo/' + this.company_uuid + "/front/promotion-category/form", hide: true},
            {label: 'Delete', type: 'delete', key: 'uuid', table: 'setting_promotion_category', title: 'title', hide: true},
          ]}
      this.tb.init(setting);
      this.cdr.detectChanges();
  }


}
